import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { CompanyEntity, EMPTY_COMPANY_ENTITY } from "domain/entity/Company/CompanyEntity";
import { CompanyTariffCodeEntity, EMPTY_COMPANY_TARIFF_CODE_ENTITY } from "domain/entity/TariffCode/CompanyTariffCodeEntity";
import { EMPTY_TARIFF_CODE_COMPANY_REQUEST_ENTITY, TariffCodeCompanyRequestEntity } from "domain/entity/TariffCode/TariffCodeCompanyRequestEntity";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { CompanyTariffCodeRepository } from "domain/repository/TariffCode/CompanyTariffCodeRepo";
import { StandardTariffCodeRepository } from "domain/repository/TariffCode/StandardTariffCodeRepo";
import { TariffTypeRepository } from "domain/repository/TariffCode/TariffTypeRepo";
import _ from "lodash";
import { tariffCodePositiveIntegerNumberFieldList } from "presentation/constant/TariffCode/TariffCodeConstant";
import { createTariffCodeByCompanyValidationSchema } from "presentation/constant/TariffCodeByCompany/TariffCodeValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { DropdownProps } from "presentation/model/DropdownProps";
import { TariffCodeByCompanyModel } from "presentation/model/TariffCodeByCompany/TariffCodeByCompanyModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface TariffCodeByCompanyVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<TariffCodeByCompanyModel>> | ((value: SetStateAction<TariffCodeByCompanyModel>) => void),
    ],
    companyTariffCodeRepo: CompanyTariffCodeRepository,
    standardTariffCodeRepo: StandardTariffCodeRepository,
    companyRepo: CompanyRepository,
    tariffTypeRepo: TariffTypeRepository,
}

export const TariffCodeByCompanyVM = ({ dispatch, companyTariffCodeRepo, standardTariffCodeRepo, companyRepo, tariffTypeRepo }: TariffCodeByCompanyVMProps) => {
    const [tariffCodeByCompanyDispatch] = dispatch;

    const loadDropdownOption = async () => {
        await tariffTypeRepo.getAllActiveTariffTypes().then(
            tariffs => {
                let newTariffs = _.orderBy(tariffs, ["tariffType"]);
                let tariffTypeDropdownOption = newTariffs?.map((tariff) => ({
                    dropdownLabel: tariff.tariffType,
                    tagLabel: tariff.tariffType,
                    value: tariff.tariffType,
                })) ?? []
                tariffCodeByCompanyDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        parentTariffTypeDropdownOptions: tariffTypeDropdownOption,
                    }
                }))
            }
        );

        await standardTariffCodeRepo.getAllStandardTariffCodes().then(
            tariffs => {

                let newTariffs = _.orderBy(tariffs, ["tariffType", "tariffCode"]);
                let tariffCodeDropdownOptions: { [key: string]: DropdownProps[] } = {};

                newTariffs?.forEach(tariff => {

                    if (tariff.tariffCode) {
                        if (!tariffCodeDropdownOptions[tariff.tariffType]) {
                            tariffCodeDropdownOptions[tariff.tariffType] = [];
                        }
                        tariffCodeDropdownOptions[tariff.tariffType].push({
                            dropdownLabel: tariff.tariffCode,
                            tagLabel: tariff.tariffCode,
                            value: tariff.tariffCode,
                        })
                    }
                })

                tariffCodeByCompanyDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        parentTariffCodeDropdownOptions: tariffCodeDropdownOptions,
                    }
                }))
            }
        )

        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                companies = companies?.filter(company => company.activeInd === 'Y');
                const companyDropdownOptions = companies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.companyCode,
                    value: company.companyCode,
                })) ?? [];

                tariffCodeByCompanyDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyDropdownOptions: companyDropdownOptions
                    }
                }))
            }
        )
    }

    const onSearchCompany = async () => {
        const companies = await companyTariffCodeRepo?.findTariffCodeCompany();

        tariffCodeByCompanyDispatch(prevState => ({
            ...prevState,
            isShowAddPanel: false,
            isShowDetail: false,
            companyEntityList: companies,
            companyTariffCodes: [],
        }))
    }



    const updateSelectedRows = async (selecedRows: CompanyEntity[]) => {
        const isSingleSelRow = selecedRows && selecedRows.length === 1 ? true : false;
        tariffCodeByCompanyDispatch(prevState => {
            return {
                ...prevState,
                isShowAddPanel: false,
                isShowDetail: isSingleSelRow ? true : false,
                selectedRows: selecedRows,
                companyTariffCodes: [],
                currentSelectedRow: isSingleSelRow ? selecedRows[0] : { ...EMPTY_COMPANY_ENTITY },
            }
        })
        if (isSingleSelRow) {
            onShowLoading();
            await onSearchCompanyTariffCode(selecedRows[0]).then(data => {
                onHideLoading();
            })
        }
    }

    const onSearchCompanyTariffCode = async (entity: CompanyEntity) => {

        await companyTariffCodeRepo?.findCompanyTariffCodeByCompanyId(entity.id).then((data) => {
            tariffCodeByCompanyDispatch(prevState => ({
                ...prevState,
                isShowAddPanel: false,
                isShowDetail: true,
                companyTariffCodes: data,
                currentSelectedRow: entity,
                detailState: {
                    ...prevState.detailState,
                    // companyTariffCodes: tariffCodeList,
                    isEditable: false,
                    isRead: true,
                    isSliderOpen: false,
                    updatedRows: [],
                    isRefresh: !prevState.detailState.isRefresh
                }
            }))

        });


    }

    const updateSelectedDetailRows = async (rows: CompanyTariffCodeEntity[]) => {
        tariffCodeByCompanyDispatch(prevState => {

            return {
                ...prevState,
                // companyTariffCodes:[...allRows],
                detailState: {
                    ...prevState.detailState,
                    // companyTariffCodes:[...allRows],
                    selecedRows: rows,
                }
            }
        })
    }

    const onHeaderMultipleDropdownChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        tariffCodeByCompanyDispatch(prevState => ({
            ...prevState,
            masterState: {
                ...prevState.masterState,
                tariffCompanyRequest: {
                    ...prevState.masterState.tariffCompanyRequest,
                    [fieldKey]: val,
                },
                allFormState: {
                    ...prevState.masterState.allFormState,
                    [fieldKey]: '',
                }
            }
        }));
    };

    const onAddClick = () => {
        tariffCodeByCompanyDispatch(prevState => {

            return {
                ...prevState,
                isShowAddPanel: true,
                isShowDetail: false,
                companyTariffCodes: [],
                masterState: {
                    ...prevState.masterState,
                    tariffCompanyRequest: EMPTY_TARIFF_CODE_COMPANY_REQUEST_ENTITY,
                }
            }
        })
    }

    const onCancel = () => {
        tariffCodeByCompanyDispatch(prevState => {

            return {
                ...prevState,
                isShowAddPanel: false,
                masterState: {
                    ...prevState.masterState,
                    tariffCompanyRequest: EMPTY_TARIFF_CODE_COMPANY_REQUEST_ENTITY,
                    allFormState: {}
                }
            }
        })
    }

    const onSaveClicked = () => {
        tariffCodeByCompanyDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onSave = async (tariffCompanyRequest: TariffCodeCompanyRequestEntity) => {
        const valResult = await Validation(createTariffCodeByCompanyValidationSchema).ValidateFormOnly(tariffCompanyRequest);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {

            validatedResult = { ...validatedResult, ...valResult };



            tariffCodeByCompanyDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return await companyTariffCodeRepo.saveMultipleTariffCompany(tariffCompanyRequest.companines as string[]);
    }

    const onDelete = async (selectedRows: CompanyEntity[]) => {

        return await companyTariffCodeRepo.deleteMultipleTariffCompanines(selectedRows);
    }


    const onDetailRowDoubleClick = (row: CompanyTariffCodeEntity) => {
        tariffCodeByCompanyDispatch(prevState => {

            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    currentSelectItem: row,
                    editingItem: {
                        ...row,
                        parentTariffType: row.parentTariffType ?? row.tariffType
                    },
                    isEditable: true,
                    isRead: false,
                    isSliderOpen: true,
                }
            }
        })
    }

    const onCloseDetail = () => {
        tariffCodeByCompanyDispatch(prevState => {
            return {
                ...prevState,
                isShowAddPanel: false,
                isShowDetail: false,
                companyTariffCodes: [],
                currentSelectedRow: EMPTY_COMPANY_ENTITY,
                detailState: {
                    ...prevState.detailState,
                    currentSelectItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
                    editingItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
                    isEditable: false,
                    isRead: true,
                    isSliderOpen: false,
                    updatedRows: [],
                }
            }
        })
    }

    const onDetailEditCancel = () => {
        tariffCodeByCompanyDispatch(prevState => {

            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    currentSelectItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
                    editingItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
                    isEditable: false,
                    isRead: true,
                    isSliderOpen: false,
                }
            }
        })
    }

    const onDetailSaveClicked = () => {
        tariffCodeByCompanyDispatch(prevState => {
            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }


    const onDetailSave = async (editingItem: CompanyTariffCodeEntity) => {
        const res = await companyTariffCodeRepo.replaceCompanyTariffCode(editingItem);
        if (!res.success) {
            return { warningMessage: res.data as string };
        }

        return tariffCodeByCompanyDispatch(prevState => {

            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    currentSelectItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
                    editingItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
                    isEditable: false,
                    isRead: true,
                    isSliderOpen: false,
                }
            }
        })
    }

    const onDetailFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        tariffCodeByCompanyDispatch(prevState => {

            if (tariffCodePositiveIntegerNumberFieldList.includes(fieldKey)) {
                var posIntReg = /^\d*$/;
                if (!posIntReg.test(val)) {
                    val = prevState.detailState.editingItem[fieldKey];
                }
            }

            return {
                ...prevState,
                detailState: {
                    ...prevState.detailState,
                    editingItem: {
                        ...prevState.detailState.editingItem,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: '',
                    }
                }
            }
        })
    }

    const onDetailRowDrag = (rows: CompanyTariffCodeEntity[]) => {
        tariffCodeByCompanyDispatch(prevState => {

            const prevRows = prevState.companyTariffCodes;
            const toChangedRows = rows.map((e, index) => ({ ...e, tempSeq: prevRows[index].seq })).filter(e => e.tempSeq !== e.seq);

            return ({
                ...prevState,
                companyTariffCodes: rows,
                detailState: {
                    ...prevState.detailState,
                    // companyTariffCodes: rows,
                    updatedRows: toChangedRows,
                }
            })
        })
    }

    const onDetailApply = async (updatedRows: CompanyTariffCodeEntity[]) => {


        return await companyTariffCodeRepo.onApply(updatedRows);
    }

    const onShowLoading = () => {
        tariffCodeByCompanyDispatch(prevState => {
            return {
                ...prevState,
                isLoading: true,
            }
        })
    }

    const onHideLoading = () => {
        tariffCodeByCompanyDispatch(prevState => {
            return {
                ...prevState,
                isLoading: false,
            }
        })
    }

    return {
        onHideLoading: onHideLoading,
        onShowLoading: onShowLoading,
        loadDropdownOption: loadDropdownOption,
        onSearchCompanyTariffCode: onSearchCompanyTariffCode,
        updateSelectedRows: updateSelectedRows,
        onHeaderMultipleDropdownChange: onHeaderMultipleDropdownChange,
        onAddClick: onAddClick,
        onCancel: onCancel,
        onSaveClicked: onSaveClicked,
        onSave: onSave,
        onDelete: onDelete,
        onSearchCompany: onSearchCompany,
        updateSelectedDetailRows: updateSelectedDetailRows,
        onDetailRowDoubleClick: onDetailRowDoubleClick,
        onCloseDetail: onCloseDetail,
        onDetailEditCancel: onDetailEditCancel,
        onDetailSaveClicked: onDetailSaveClicked,
        onDetailSave: onDetailSave,
        onDetailFieldChange: onDetailFieldChange,
        onDetailRowDrag: onDetailRowDrag,
        onDetailApply: onDetailApply,
    }
}